import { useMsal } from '@azure/msal-react'
import { Box, Typography } from '@mui/material'
import React from 'react'

function Profile(): React.JSX.Element {
	const { instance } = useMsal()

	return (
		<Box
			id='profile'
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				height: '100%',
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						marginBlockStart: '1rem',
					}}
				>
					<Typography
						variant='h2'
						sx={{ fontFamily: 'var(--font-family)', color: 'var(--primary-dark)' }}
					>
						Perfil
					</Typography>
				</Box>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						marginBlockStart: '1rem',
					}}
				>
					<Typography
						variant='h6'
						sx={{ fontFamily: 'var(--font-family)', color: 'var(--primary-dark)' }}
					>
						<strong>Username:</strong> {instance.getAllAccounts()[0].username}
					</Typography>
				</Box>
			</Box>
		</Box>
	)
}

export default Profile
